import React from 'react';
import styles from './tab.less';
var Tab = function Tab(_ref) {
  var id = _ref.id,
    value = _ref.value,
    onSelectedTab = _ref.onSelectedTab,
    selectedTab = _ref.selectedTab,
    path = _ref.path,
    pageTitle = _ref.pageTitle;
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(styles.tabWrapper, " ").concat(selectedTab === id ? styles.active : '')
  }, /*#__PURE__*/React.createElement("button", {
    className: "tab",
    id: id,
    type: "button",
    onClick: function onClick() {
      return onSelectedTab(id, path, pageTitle);
    },
    role: "tab",
    "aria-selected": selectedTab === id,
    tabIndex: selectedTab === id ? 0 : -1,
    "aria-controls": "tabcontent-".concat(id),
    "data-testid": "tab-".concat(id)
  }, /*#__PURE__*/React.createElement("span", null, value)));
};
export default Tab;